// Style → example sample images (Style system, 2026-07-11).
//
// Maps a style NAME → an array of directly-fetchable sample-card image URLs shown as thumbnails in the
// "Pick a style" step (and enlarged in the looping lightbox). Each style carries THREE curated examples.
// All were generated via the live store (real gpt-image-2 pipeline) with the style as the ONLY driver
// (empty feeling → style-pure), across a consistent set of subjects (rose / mountain sunset / songbird)
// so styles are comparable. Each generation was mapped back to its style DETERMINISTICALLY from the
// card's own provenance.inputs.styleId. Every URL is a stable, publicly-served, non-expiring
// /uploads/cards/…/preview.webp?v= cover.
//
// CLAUDE-OWNED DATA FILE — do NOT overwrite/skeleton this once populated. The UI degrades gracefully: a
// style with NO samples shows a calm placeholder tile. Keys EXACTLY equal the names in styleTaxonomy.js.

const BASE = 'https://api.imobituary.com/uploads/cards';
const s = (card, img, v) => `${BASE}/${card}/images/${img}/preview.webp?v=${v}`;

export const STYLE_SAMPLES = {
  'Watercolor': [
    s('40fb63dc-0ac3-4f7f-92f3-627b2294c340', '9a99813d-adb0-4278-a192-29a562556cfc', '1783789992142'),
    s('4342fe18-f4cf-47d0-b775-ea67e0ff628b', '4a9ced3e-28f1-4bae-a0f5-c3010b15a6e3', '1783789994486'),
    s('3ccbcd4d-1763-471c-9e24-4f4b49778aaf', '9547b40f-d2d9-43bb-b447-5931e3bd33f0', '1783789996871'),
  ],
  'Botanical': [
    s('58cf3dd4-7e29-4b58-a339-128cd7e6f5dd', '165df98f-9f17-4213-9544-26ba5d7d5fd7', '1783789999295'),
    s('38c464dd-df1c-47a0-b413-df3e9e74d646', '1fd2bc18-4525-4d7f-9969-bfc1639ca7d3', '1783790001728'),
    s('9c9c282e-e754-47a9-ac87-aa1b390c5764', '3ea2a857-8722-4fed-bf93-48d21b891d75', '1783790020340'),
  ],
  'Photographic': [
    s('602a5419-e143-45aa-93af-71105ac7b5e3', '3ad9e68d-0adc-4de0-8575-3b390c9573ed', '1783790995053'),
    s('92e63ef5-04d6-41d5-b149-0d894ef0da0c', 'b5f517c3-b0e9-4183-a696-eb2eb1dd60a9', '1783790997319'),
    s('99fdeb9a-dc96-4aee-aaca-9dcd80f20e8e', '2024b3f7-142f-42cb-aebe-7b3b5d3dfdbb', '1783790999447'),
  ],
  'Illustrated': [
    s('0ca127c0-8b16-4c84-bb20-8425a729d27e', '725d9be1-ad20-4d70-8e69-3064801a40b0', '1783790023088'),
    s('3b7257ef-9afb-49e3-94d6-6e7a5cfc20d4', '80251678-14b3-49ac-9747-b761f5c2ea26', '1783790195310'),
    s('eec0e14e-0b0e-440d-befb-6023dd5c8043', 'df16c080-59f5-4fcd-866e-ff17a3f25478', '1783790197568'),
  ],
  'Minimal': [
    s('2e02301d-901d-4488-9fe2-de0783851096', '02a662a1-ea85-49b5-af86-698d248612d9', '1783790199906'),
    s('f2e0421a-5558-4604-a986-3c6e48cf1eda', '91fca168-b244-4080-a3a4-be4e96db830e', '1783790201956'),
    s('2801b17a-ab0e-4ff7-81ba-5f9f7f7c7b58', '75b180a0-fb35-4115-991d-bfd9646e353d', '1783790204122'),
  ],
  'Whimsical': [
    s('032b047c-76a1-4ff9-80df-30654c5b89b7', 'e82c8352-a423-49a4-b3c5-632971ae7b2a', '1783790206283'),
    s('600c2a90-841f-4e49-94a1-04e473bf0e71', 'e6d21f1f-73ad-4cd9-aaaf-30f771a77678', '1783791001578'),
    s('edcdba04-0b3e-4431-94c4-760b921fbb11', 'fae4f090-f498-404e-8431-cacb821d3be2', '1783791003817'),
  ],
  'Cartoon': [
    s('5e2303d9-8718-4ac0-b551-c1cc14f206f3', 'c90951ac-0c46-44b7-abe6-ef377df36d15', '1783790208986'),
    s('3859f499-25b9-46ae-b224-f37161390f59', 'a0582b6d-98c0-4472-b3bd-873b1e3b896b', '1783790389637'),
    s('45c3dae1-59e3-412f-9251-a635d7741b9f', 'bd538227-e091-46bf-ae46-87c2d28cbd19', '1783791006121'),
  ],
  // Regenerated 2026-07-13 after the per-style art-direction map shipped (Anime → cel-shaded cue).
  // Prior 3 read soft/painterly; these read true cel-shaded anime (rose interior, mountain sunset, winter cardinal).
  'Anime': [
    s('92c6970d-d159-4258-8645-58f6fb9b6c79', 'd4fd69bd-e97a-42b6-b239-552bcb397c4e', '1783902122870'),
    s('6f3e8c73-a1ae-41c4-8d5f-ac6dde944fe6', '8eb38517-9027-4f6d-821a-c7a40296f8ee', '1783902245118'),
    s('6cb6b341-bc59-4fa1-8043-f4f6876e0826', 'da5fabde-26d1-4f92-8088-2b1701ce4756', '1783902247661'),
  ],
  'Comic book': [
    s('d4675976-8361-4aab-a4c7-3155c524743a', '242691b5-20a5-4e93-8925-ededcf81c400', '1783790398684'),
    s('ed1affdc-7ab6-4e4b-b633-bb4036450ce2', 'b997d2c1-730f-4fe9-b358-8a605ba80c39', '1783790401233'),
    s('57363e34-e281-40a2-89ab-d88ad7b5bd42', 'ddf38afb-7f16-4c76-8469-b05fa19655ff', '1783791330918'),
  ],
  'Pop art': [
    s('233fb9cb-bf18-4743-9f58-6f24f9bdc9e6', '0968841f-2968-4c25-8438-bd78e11bea60', '1783790404050'),
    s('5b29d905-c14f-4396-b3d1-15a6ba034d82', 'b29d5ba9-a6a7-4672-8f1e-9c2879019605', '1783791333205'),
    s('0197c813-7a13-4d36-9026-118adcb863a4', '4bd3a5af-09f4-412a-897d-828786cca3d9', '1783791335521'),
  ],
  'Oil painting': [
    s('a71854e0-10bb-4ef0-ac86-810a285c43a3', 'ca1d09e5-bbf4-4e22-88fb-7c4f2224706f', '1783790580218'),
    s('91b4fca5-43f0-429d-b8d4-093c7e3a6570', '3ca1689f-9bfa-4531-81f6-ca0dc4c52598', '1783790582701'),
    s('385c04f7-47a5-4221-9e8e-822f24fec5fe', '23e1b43e-baeb-45b7-a3c8-3c4540be8ff9', '1783790585023'),
  ],
  'Pencil sketch': [
    s('398b7b3e-a83b-4c29-a228-d4ce4c9df889', '73a85245-30c3-4998-a3fe-bdd8db2b66b1', '1783790587462'),
    s('e804552b-a7ad-4495-ac06-07755ba93542', 'b5615183-ca3a-45fa-84b0-089199640bd5', '1783790589675'),
    s('3271ce6e-da7d-4eb0-b185-41332aea9096', '5f1ce45f-b2ab-44ac-9c6a-0346bdf4df68', '1783790592093'),
  ],
  '3D animation': [
    s('f4b5b0ea-da46-49c6-9e0c-3cedbd54a83f', '4611d4a0-7476-43a9-8888-b27f02ea399b', '1783791008672'),
    s('a62ee8a3-61e4-4432-b2b6-09fb8b91cd2c', '5102d105-558b-4482-94b1-cfd735afa386', '1783791163497'),
    s('2ef29aa4-db33-470d-a60a-9122c0f40b09', '007c0161-2937-4c6e-9dc8-1a16b168ae0f', '1783791165579'),
  ],
  'Pixel art': [
    s('03417f81-7cb0-462f-851c-cba55b7af7cc', '04961524-bc05-4b54-90a7-7f772a22899d', '1783790594738'),
    s('73151864-e533-4ac0-ae6e-93f70c4631cc', 'a5a019e6-e5c0-4641-be61-8135cac1074d', '1783790778768'),
    s('f2992531-c082-4ac5-8b5d-d32a576a2e2b', '2302447d-c654-4c7e-befb-cb12efa83c55', '1783790780884'),
  ],
  'Vintage': [
    s('684e6286-6a00-452d-9dcc-9824d003004e', '7b5b7b09-00bf-46db-9beb-6ee4f85f323e', '1783790783078'),
    s('c9223082-db17-46bf-8c50-6931a58527fc', '8c594434-13ae-4f68-ac90-c3752b794739', '1783790785194'),
    s('dde82d29-a705-446f-bace-823e1e2de824', '4415afa8-edde-4b85-973f-2f78a13776ab', '1783790787389'),
  ],
  'Storybook': [
    s('ee070e3c-06be-4a78-bd73-082777d94f2c', '7acbea12-926e-4af0-82e9-35081ec0298f', '1783790789728'),
    s('b2db1826-83d4-4436-9ea3-73de991038a4', '945200eb-842a-4b7c-94a1-9605ba128632', '1783791167662'),
    s('7c70cabb-0fbf-4346-b23e-0e107b66aec3', '41357a0a-dac9-4517-a709-4ba20b52cb90', '1783791169988'),
  ],
  'Stained glass': [
    s('43ef3190-932d-441b-b449-61543b5ac099', '30a00087-c2f2-4c24-adf0-12dbda9ea1ae', '1783791172241'),
    s('3c5963a0-4390-495a-a984-1691adec6bb4', '6054a77a-2cc9-41d5-8fdd-49e0b33416b6', '1783791174648'),
    s('0ad6a789-7570-4a2f-b2fc-a1cc480f6727', '313163c6-4687-4fc0-90f5-4ce117c13920', '1783791337730'),
  ],
  'Line art': [
    s('a2a1e8fb-f1c9-4f25-b42e-9cfaf7d5d20d', '81e4dac0-7a60-4cf9-8cab-9d12ac272ce7', '1783790792658'),
    s('69d79bb6-1efd-4e31-8860-767ef8d5b915', '38be504f-8b20-47cd-9508-c4e3ca01e292', '1783791340100'),
    s('5112e040-2c13-46ba-9946-88bdf2ca08b0', '2f08e399-7d37-47ff-83be-2771028912a4', '1783791342479'),
  ],
  // Woodcut (19th style) — generated 2026-07-14 via the LIVE gpt-image-2 pipeline with the new 'woodcut'
  // cue as the ONLY driver (empty feeling → style-pure), standard subjects (rose / mountain sunset /
  // songbird). All read as true black-ink woodcut/engraving; each verified serving 200 (1024×1536).
  'Woodcut': [
    s('9a0de5a2-688d-4954-9285-c642323ac825', '9a0af323-2cc6-4b63-8fdf-f7f334ba8a4e', '1784064717322'),
    s('98dbe06a-faf3-4b49-906d-5a69b77c231d', '28319598-de09-4299-9e07-c2c1eae5e133', '1784064719364'),
    s('54431ce2-de14-4a7e-a1ae-187ca4f574d5', '389adbe1-c77a-4516-80fe-b15b5d866cd7', '1784064721597'),
  ],
};

/** Sample image URLs for a style (empty array when none are curated yet). */
export function samplesForStyle(name) {
  const list = STYLE_SAMPLES[name];
  return Array.isArray(list) ? list : [];
}
